import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useGetAllDaysSelect } from '../../sales/Suppliers/hooks/SalesSupplierHook';
import { ConciliationGrid } from './ConciliationGrid';
import { styleSelect, themeSelect } from '../../../../rbts/assets/ts/_utils';
import { ConciliationForm } from './ConciliationForm';
import {
  useExecuteCloseCurrentDay,
  useSelectSuppliersForConciliation,
} from '../hooks/ConsilationHook';
import { MensajeDia } from '../../../../rbts/helpers/components/MensajeDia';
import { SimpleAlert } from '../../../../rbts/helpers';
import { executeAllConciliation } from '../../../service/conciliation/Conciliation';
import { generarPdfMasivo } from './ConciliacionMasivaPdf';

type Props = {};

const View: React.FC<Props> = ({}) => {
  const [reloadTipo, setReloadTipo] = useState<number>(Math.random() * 40);
  const { suppliers, loadingRequest } = useSelectSuppliersForConciliation(reloadTipo);

  const [supplierSelected, setSupplierSelected] = useState<any | null>([]);
  const [showSaleForm, setShowSaleForm] = useState<boolean>(false);
  const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
  const { catalog: day } = useGetAllDaysSelect(reloadInfo);
  const [strDate, setStrDate] = useState<string>('');
  const [currentDay, setCurrentDay] = useState<number>(0);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const { loadingCloseDay, closeDay } = useExecuteCloseCurrentDay();
  const [isDisabledBtnCloseDay, setIsDisabledBtnCloseDay] =
    useState<boolean>(false);

  // Conciliar Todos
  const [conciliarTodos, setConciliarTodos] = useState<boolean>(false);
  const [loadingConciliarTodos, setLoadingConciliarTodos] = useState<boolean>(false);

  useEffect(() => {
    if (day) {
      const {
        dia: { id },
        fecha_str,
      } = day;
      setStrDate(fecha_str);
      setCurrentDay(id);
      setIsDisabledBtnCloseDay(false);
    } else {
      setIsDisabledBtnCloseDay(true);
    }
  }, [day]);

  const handleSupplierOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setSupplierSelected(selectedOption);
      setIsDisabled(false);
    } else {
      setSupplierSelected(null);
      setIsDisabled(true);
      setShowSaleForm(false);
    }
  };

  const closeSecction = () => {
    setShowSaleForm(false);
    setSupplierSelected(null);
    setIsDisabled(true);
    setReloadTipo(Math.random() * 40);
  };

  const handleConciliarTodos = async () => {
    const confirmResult = await Swal.fire({
      title: '¿Conciliar todos los puntos de venta?',
      html: 'Se conciliarán <strong>todos</strong> los puntos de venta pendientes en una sola operación transaccional. Esta acción <strong>no se puede deshacer</strong>.',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-light',
      },
    });

    if (!confirmResult.isConfirmed) return;

    // Mostrar modal de progreso
    Swal.fire({
      title: 'Conciliando...',
      html: `
        <p class="text-muted mb-4">Procesando todos los puntos de venta, por favor espere.</p>
        <div class="progress" style="height: 22px; border-radius: 6px; overflow: hidden;">
          <div id="prog-bar"
               class="progress-bar progress-bar-striped progress-bar-animated bg-warning fw-bold"
               role="progressbar"
               style="width: 5%; transition: width 0.4s ease; color: #000;">
            5%
          </div>
        </div>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    // Animación de progreso (simulada hasta 85% mientras la API responde)
    let progress = 5;
    const interval = setInterval(() => {
      progress = Math.min(progress + 3, 85);
      const bar = document.getElementById('prog-bar');
      if (bar) {
        bar.style.width = `${progress}%`;
        bar.textContent = `${progress}%`;
      }
    }, 300);

    setLoadingConciliarTodos(true);
    try {
      const conciliaciones = await executeAllConciliation();

      // Completar a 100%
      clearInterval(interval);
      const bar = document.getElementById('prog-bar');
      if (bar) { bar.style.width = '100%'; bar.textContent = '100%'; }
      await new Promise((resolve) => setTimeout(resolve, 500));
      Swal.close();

      // Generar y descargar PDF con secciones por tipo
      await generarPdfMasivo(conciliaciones, strDate);

      SimpleAlert(
        `Conciliación masiva completada: ${conciliaciones.length} punto(s) de venta conciliados`,
        4000,
        'success'
      );
      setReloadTipo(Math.random() * 40);
      setReloadInfo(Math.random() * 40);
      setConciliarTodos(false);
    } catch (err: any) {
      clearInterval(interval);
      Swal.close();
      const msg =
        err?.response?.data?.message ||
        'Error en la conciliación masiva, intenta nuevamente.';
      SimpleAlert(msg, 3000, 'error');
    } finally {
      setLoadingConciliarTodos(false);
    }
  };

  return (
    <>
      {currentDay === 0 ? (
        <MensajeDia mensaje={''} />
      ) : (
        <>
          <div className="d-flex flex-column flex-xl-row">
            <div className="col-xl-12">
              <div className="card mb-5">
                      <div className="card-header border-0">
                        <h3 className="card-title align-items-start flex-column">
                          <span className="card-label fw-bold text-gray-800">
                            Búsqueda por punto de venta
                          </span>
                        </h3>
                        {/* ── Checkbox Conciliar Todos ── */}
                        <div className="card-toolbar">
                          <div className="form-check form-check-custom form-check-solid">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="chk_conciliar_todos"
                              checked={conciliarTodos}
                              disabled={loadingConciliarTodos}
                              onChange={(e) => {
                                setConciliarTodos(e.target.checked);
                                if (e.target.checked) {
                                  setSupplierSelected(null);
                                  setIsDisabled(true);
                                  setShowSaleForm(false);
                                }
                              }}
                            />
                            <label
                              className="form-check-label fw-bold ms-2"
                              htmlFor="chk_conciliar_todos"
                            >
                              Conciliar Todos
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-12 col-md-4 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="w-100 pe-5">
                              <div className="w-100 d-flex">
                                <label className="required form-label w-auto">
                                  Nombre:{' '}
                                </label>
                              </div>
                              <Select
                                options={suppliers.filter(
                                  (s: any) =>
                                    s.label?.toLowerCase() !== 'recarga en línea'
                                )}
                                value={supplierSelected}
                                styles={styleSelect}
                                theme={themeSelect}
                                classNamePrefix="tc-select"
                                placeholder={'Seleccione'}
                                isSearchable={true}
                                noOptionsMessage={() => {
                                  return (
                                    <span>{'No se encontraron registros'}</span>
                                  );
                                }}
                                onChange={handleSupplierOnChange}
                                isLoading={loadingRequest}
                                isClearable
                                backspaceRemovesValue
                                isDisabled={conciliarTodos || loadingConciliarTodos}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="w-100 pe-5">
                              <div className="w-100 d-flex">
                                <label className="form-label w-auto">
                                  Nombre:{' '}
                                </label>
                              </div>
                              <div className="w-100 d-flex">
                                <span
                                  className="form-control border-0 text-muted fs-6"
                                  style={{ paddingLeft: '0px' }}
                                >
                                  {supplierSelected?.label
                                    ? supplierSelected.label
                                    : 'Seleccione el puesto'}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="w-100 pe-5">
                              <div className="w-100 d-flex">
                                <label className="form-label w-auto">
                                  Tipo:{' '}
                                </label>
                              </div>
                              <div className="w-100 d-flex">
                                <span
                                  className="form-control border-0 text-muted pl-0"
                                  style={{ paddingLeft: '0px' }}
                                >
                                  {supplierSelected?.data?.tipo
                                    ? supplierSelected.data.tipo
                                    : 'Seleccione el puesto'}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="w-100 pe-5">
                              {!conciliarTodos ? (
                                <button
                                  type="button"
                                  title="Buscar"
                                  disabled={isDisabled}
                                  onClick={() => {
                                    setShowSaleForm(!showSaleForm);
                                  }}
                                  className={`btn w-200px ${
                                    !showSaleForm ? 'btn-primary' : 'btn-light'
                                  }`}
                                >
                                  <span className="indicator-label">
                                    {!showSaleForm ? 'Buscar' : 'Cancelar'}
                                  </span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={handleConciliarTodos}
                                  disabled={loadingConciliarTodos}
                                  className="btn btn-warning w-200px"
                                >
                                  {loadingConciliarTodos ? (
                                    <span
                                      className="indicator-progress"
                                      style={{ display: 'block' }}
                                    >
                                      Espere...
                                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                  ) : (
                                    <span className="indicator-label">
                                      Conciliar Todos
                                    </span>
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
              </div>

              {!showSaleForm ? (
                <>
                  <div className="card mb-5">
                    <div className="card-header border-0">
                      <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">
                          Conciliaciones realizadas
                        </span>
                      </h3>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                          <ConciliationGrid
                            reloadGrid={reloadInfo}
                            strDate={strDate}
                          ></ConciliationGrid>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              {showSaleForm ? (
                <div className="card">
                  <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Ventas
                      </span>
                    </h3>
                    <h3 className="card-title">
                      <span className="card-label fw-bold text-gray-800">
                        Fecha administrativa:
                      </span>
                      <span className="fs-4 text-gray-700">{strDate}</span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row w-100 ">
                      <div className="col-md-12 ">
                        <ConciliationForm
                          supplierId={supplierSelected?.value}
                          dayId={currentDay}
                          handleClose={closeSecction}
                        ></ConciliationForm>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export { View };
